import React, { useState, useEffect } from 'react';
import "../css/Countdown.css";

const CountdownTimer = ({ targetTime, targetTime_pa, setlang }) => {
  // State to store user input time and current countdown
  const [timeLeft, setTimeLeft] = useState(null);
  const [daysLeft, setdayLeft] = useState(null);
  const [hoursLeft, setHrLeft] = useState(null);
  const [minutesLeft, setMinLeft] = useState(null);
  const [secondsLeft, setSecLeft] = useState(null);

  const toPersiDigits = (str) =>
    str.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  // Function to calculate the remaining time
  const calculateTimeLeft = () => {
    if (!targetTime) return;

    const currentTime = new Date();
    const targetDate = new Date(targetTime);
    const difference = targetDate - currentTime;

    if (difference <= 0) {
      setTimeLeft(setlang==="en"?'Time is up!':'مزایده به پایان رسید');
    } else {
      const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60 ));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      setdayLeft(days);
      setHrLeft(hours);
      setMinLeft(minutes);
      setSecLeft(seconds);
    }
  };

  // Update countdown every second
  useEffect(() => {
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer); // Clean up the interval on unmount
  }, [targetTime]); // Dependency on targetTime

  return (
    <>
    <div className={setlang === "en" ? 'countdown': 'countdown-fa' }>
      {setlang ==="en"?
        <div className='countdown-deadline-mini'> <p style={{fontWeight:'Bold'}}>Bidding Deadline: </p> <p style={{direction:"ltr"}}> {(targetTime_pa)}</p></div>
        :
        <div className='countdown-deadline-mini-fa'> <p style={{fontWeight:'Bold'}}>تاریخ پایان مزایده: </p> <p style={{direction:"ltr"}}> {toPersiDigits(targetTime_pa)}</p></div>
      }
      
      <div className={setlang === "en" ? 'countdown-cont-mini' : 'countdown-cont-mini-fa' }>
        <p style={{alignContent:'center', fontWeight:"bold"}}>{setlang==="en"? "Time Left: " : " زمان باقی مانده: "}</p> 
        
        <span>{timeLeft}</span>

        {/*
          <div>
          {timeLeft === null ? '...' : timeLeft}
        </div>
        */}
      
      </div>
    </div>
    </>
  );
};

export default CountdownTimer;